// Vendors
import { CookiesStorage } from '@openbank/cf-ui-framework';
import { StorageCookiesEnum } from '@openbank/ziniaweb-ui-core-models';
const getAccessToken = () => CookiesStorage.getItem(StorageCookiesEnum.ACCESS_TOKEN) ?? '';
export const defaultMessageParser = (message) => {
    try {
        return JSON.parse(message);
    }
    catch {
        return message;
    }
};
export const getDefaultUrl = () => {
    const accessTokenUrlString = `?accessToken=${getAccessToken()}`;
    return `${window.WEBSOCKET_DOMAIN_URL}${accessTokenUrlString}`;
};
export const getStringUrl = (url) => (typeof url === 'function' ? url() : url);
const webSocketHasLegitInitMessage = (initMessage) => Boolean(typeof initMessage === 'object' && initMessage?.endpoint && initMessage?.detail);
export const parseSentData = (data) => typeof data === 'string'
    ? data
    : JSON.stringify({
        ...data,
        detail: {
            ...data?.detail,
            headers: {
                accessToken: getAccessToken(),
                ...data?.detail?.headers,
            },
        },
    });
export { webSocketHasLegitInitMessage };
//# sourceMappingURL=useWebSockets.utils.js.map